// Brand assets centralized for easy swap.
export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_livestock-market-hub/artifacts/d7ynu37j_WhatsApp%20Image%202026-06-29%20at%2017.57.53.jpeg";
